<div class="conversation-advanced-filter" (click)="onPanelClick($event)">

  <div class="conversation-advanced-filter__body">
    <h4 class="conversation-advanced-filter__title">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.title' | translate }}</h4>

    <!-- Accounts (multi-select picklist) -->
    <div class="conversation-advanced-filter__field" *ngIf="accounts.length">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.accounts_label' | translate }}</label>
      <div class="caf-select" [matMenuTriggerFor]="accountsMenu">
        <div class="caf-select__tags" *ngIf="selectedAccounts.length; else accountsPlaceholder">
          <span class="caf-tag" *ngFor="let account of selectedAccounts">
            <span class="caf-tag__text">{{ account.mailbox_type === 'shared' ? ('smart_inbox.inbox_view.sidebar_nav.shared_with_me' | translate) : account.name }}</span>
            <mat-icon class="caf-tag__remove" (click)="toggleAccount(account.id); $event.stopPropagation()">close</mat-icon>
          </span>
        </div>
        <ng-template #accountsPlaceholder>
          <span class="caf-select__placeholder">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.all_option' | translate }}</span>
        </ng-template>
        <ui-svg-icon class="caf-select__caret" svgIcon="chevron_down" size="small"></ui-svg-icon>
      </div>
    </div>
    <mat-menu #accountsMenu="matMenu" class="inbox-menu" panelClass="caf-menu-panel">
      <div class="caf-options" (click)="$event.stopPropagation()">
        <label class="caf-option" *ngFor="let account of accounts">
          <mat-checkbox [checked]="selectedAccountIds.includes(account.id)" (change)="toggleAccount(account.id)"></mat-checkbox>
          <ui-svg-icon [svgIcon]="account.mailbox_type === 'team' || account.mailbox_type === 'shared' ? 'persons' : 'inbox'" size="small"></ui-svg-icon>
          <span class="caf-option__label">{{ account.mailbox_type === 'shared' ? ('smart_inbox.inbox_view.sidebar_nav.shared_with_me' | translate) : account.name }}</span>
        </label>
      </div>
    </mat-menu>

    <!-- Categories (colored toggle tags) -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.categories_label' | translate }}</label>
      <div class="caf-cat-tags">
        <!-- Same tag component as the inbox, so a category reads identically
             wherever it appears. Unselected tags render muted. -->
        <ui-ai-classification-tag *ngFor="let category of conversationCategories"
                                  size="small"
                                  [editable]="true"
                                  [caret]="false"
                                  [variant]="selectedCategories.includes(category.type) ? 'tint' : 'muted'"
                                  [tone]="category.type"
                                  [label]="classificationLabelKey(category.type) | translate"
                                  (tagClick)="toggleCategory(category.type)">
        </ui-ai-classification-tag>
      </div>
    </div>

    <!-- Counterparty (colored toggle tags), independent of the category. -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.counterparty_label' | translate }}</label>
      <div class="caf-cat-tags">
        <ui-ai-classification-tag *ngFor="let counterparty of counterpartyOptions"
                                  size="small"
                                  [editable]="true"
                                  [caret]="false"
                                  [variant]="counterpartyFilterVariant(selectedCounterparties.includes(counterparty))"
                                  [tone]="counterparty"
                                  [label]="counterpartyLabelKey(counterparty) | translate"
                                  (tagClick)="toggleCounterparty(counterparty)">
        </ui-ai-classification-tag>
      </div>
    </div>

    <!-- Status (multi-select picklist) -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.status_label' | translate }}</label>
      <div class="caf-select" [matMenuTriggerFor]="statusMenu">
        <div class="caf-select__tags" *ngIf="selectedStatusItems.length; else statusPlaceholder">
          <span class="caf-tag" [class]="'status-' + status.type" *ngFor="let status of selectedStatusItems">
            <span class="caf-tag__text">{{ ('smart_inbox.inbox_view.detail.status_' + status.type) | translate }}</span>
            <mat-icon class="caf-tag__remove" (click)="toggleStatus(status.type); $event.stopPropagation()">close</mat-icon>
          </span>
        </div>
        <ng-template #statusPlaceholder>
          <span class="caf-select__placeholder">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.all_option' | translate }}</span>
        </ng-template>
        <ui-svg-icon class="caf-select__caret" svgIcon="chevron_down" size="small"></ui-svg-icon>
      </div>
    </div>
    <mat-menu #statusMenu="matMenu" class="inbox-menu" panelClass="caf-menu-panel">
      <div class="caf-options" (click)="$event.stopPropagation()">
        <label class="caf-option" *ngFor="let status of conversationStatuses">
          <mat-checkbox [checked]="selectedStatuses.includes(status.type)" (change)="toggleStatus(status.type)"></mat-checkbox>
          <ui-svg-icon [svgIcon]="status.type" size="small"></ui-svg-icon>
          <span class="caf-option__label">{{ ('smart_inbox.inbox_view.detail.status_' + status.type) | translate }}</span>
        </label>
      </div>
    </mat-menu>

    <!-- Urgent only -->
    <div class="conversation-advanced-filter__field conversation-advanced-filter__field--checkbox">
      <mat-checkbox [formControl]="form.controls.isUrgent">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.urgent_only' | translate }}</mat-checkbox>
    </div>

    <!-- Assignee (multi-select picklist + assigned-to-me) -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.assignee_label' | translate }}</label>
      <div class="caf-select" [matMenuTriggerFor]="assigneeMenu">
        <div class="caf-select__tags" *ngIf="selectedAssigneeUsers.length; else assigneePlaceholder">
          <span class="caf-tag" *ngFor="let user of selectedAssigneeUsers">
            <span class="caf-tag__avatar" [style.background-color]="getUserColor(user)">{{ getUserInitials(user) }}</span>
            <span class="caf-tag__text">{{ getUserFullname(user) }}</span>
            <mat-icon class="caf-tag__remove" (click)="toggleAssignee(user.id); $event.stopPropagation()">close</mat-icon>
          </span>
        </div>
        <ng-template #assigneePlaceholder>
          <span class="caf-select__placeholder">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.all_option' | translate }}</span>
        </ng-template>
        <ui-svg-icon class="caf-select__caret" svgIcon="chevron_down" size="small"></ui-svg-icon>
      </div>
    </div>
    <mat-menu #assigneeMenu="matMenu" class="inbox-menu" panelClass="caf-menu-panel">
      <div class="caf-options" (click)="$event.stopPropagation()">
        <label class="caf-option caf-option--me" *ngIf="currentUser">
          <mat-checkbox [checked]="isAssignedToMe" (change)="toggleAssignedToMe()"></mat-checkbox>
          <span class="caf-option__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.assigned_to_me' | translate }}</span>
        </label>
        <label class="caf-option" *ngFor="let user of getUsersButCurrentUser()">
          <mat-checkbox [checked]="selectedAssigneeIds.includes(user.id)" (change)="toggleAssignee(user.id)"></mat-checkbox>
          <span class="caf-option__avatar" [style.background-color]="getUserColor(user)">{{ getUserInitials(user) }}</span>
          <span class="caf-option__label">{{ getUserFullname(user) }}</span>
        </label>
      </div>
    </mat-menu>

    <!-- Team (multi-select: the backend takes team_ids and unions their members) -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.team_label' | translate }}</label>
      <div class="caf-select" [matMenuTriggerFor]="teamMenu">
        <div class="caf-select__tags" *ngIf="selectedTeams.length; else teamPlaceholder">
          <span class="caf-tag" *ngFor="let team of selectedTeams">
            <span class="caf-tag__text">{{ team.name }}</span>
            <mat-icon class="caf-tag__remove" (click)="toggleTeam(team.id); $event.stopPropagation()">close</mat-icon>
          </span>
        </div>
        <ng-template #teamPlaceholder>
          <span class="caf-select__placeholder">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.all_option' | translate }}</span>
        </ng-template>
        <ui-svg-icon class="caf-select__caret" svgIcon="chevron_down" size="small"></ui-svg-icon>
      </div>
    </div>
    <mat-menu #teamMenu="matMenu" class="inbox-menu" panelClass="caf-menu-panel">
      <div class="caf-options" (click)="$event.stopPropagation()">
        <label class="caf-option" *ngFor="let team of teams">
          <mat-checkbox [checked]="selectedTeamIds.includes(team.id)" (change)="toggleTeam(team.id)"></mat-checkbox>
          <span class="caf-option__label">{{ team.name }}</span>
        </label>
        <span class="caf-option caf-option--empty" *ngIf="!teams.length">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.no_teams_found' | translate }}</span>
      </div>
    </mat-menu>

    <!-- Label (multi-select: the backend takes applied_label_ids, matching ANY of them) -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.label_label' | translate }}</label>
      <div class="caf-select" [matMenuTriggerFor]="labelMenu">
        <div class="caf-select__tags" *ngIf="selectedLabels.length; else labelPlaceholder">
          <span class="caf-tag" *ngFor="let label of selectedLabels">
            <span class="caf-tag__text">{{ label.name }}</span>
            <mat-icon class="caf-tag__remove" (click)="toggleLabel(label.id); $event.stopPropagation()">close</mat-icon>
          </span>
        </div>
        <ng-template #labelPlaceholder>
          <span class="caf-select__placeholder">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.all_option' | translate }}</span>
        </ng-template>
        <ui-svg-icon class="caf-select__caret" svgIcon="chevron_down" size="small"></ui-svg-icon>
      </div>
    </div>
    <mat-menu #labelMenu="matMenu" class="inbox-menu" panelClass="caf-menu-panel">
      <div class="caf-options" (click)="$event.stopPropagation()">
        <label class="caf-option" *ngFor="let label of labels">
          <mat-checkbox [checked]="selectedLabelIds.includes(label.id)" (change)="toggleLabel(label.id)"></mat-checkbox>
          <span class="caf-option__label">{{ label.name }}</span>
        </label>
        <span class="caf-option caf-option--empty" *ngIf="!labels.length && labelsLoading" data-testid="label-filter-loading">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.labels_loading' | translate }}</span>
        <span class="caf-option caf-option--empty" *ngIf="!labels.length && !labelsLoading" data-testid="label-filter-empty">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.no_labels_found' | translate }}</span>
      </div>
    </mat-menu>

    <!-- Customer autocomplete -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.customer_label' | translate }}</label>
      <div class="conversation-advanced-filter__customer-chips" *ngIf="selectedCustomers.length">
        <span class="conversation-advanced-filter__chip" *ngFor="let customer of selectedCustomers">
          {{ customer.displayName }}
          <mat-icon class="conversation-advanced-filter__chip-remove" (click)="removeCustomer(customer.id)">close</mat-icon>
        </span>
      </div>
      <input
        type="text"
        class="conversation-advanced-filter__customer-input"
        [formControl]="customerSearchControl"
        [placeholder]="'smart_inbox.inbox_view.conversation_list.advanced_filter.placeholder_search_customers' | translate"
        [matAutocomplete]="customerAuto"
      />
      <mat-autocomplete #customerAuto="matAutocomplete" class="customer-autocomplete-panel" (opened)="onAutocompletePanelOpened()" (optionSelected)="selectCustomer($event.option.value)">
        <mat-option *ngFor="let location of customerLocations" [value]="location">
          {{ getLocationDisplayName(location) }}
        </mat-option>
        <mat-option *ngIf="customerLoading" disabled>{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.customer_loading' | translate }}</mat-option>
        <mat-option *ngIf="!customerLoading && customerLocations.length === 0" disabled>{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.no_customers_found' | translate }}</mat-option>
      </mat-autocomplete>
    </div>

    <!-- Divider: thread attributes above · email content below -->
    <hr class="conversation-advanced-filter__divider" />

    <!-- From (sender) -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.from_label' | translate }}</label>
      <ui-form-field type="text" [formControl]="form.controls.from" [placeholder]="'smart_inbox.inbox_view.conversation_list.advanced_filter.placeholder_sender' | translate" [fullWidth]="true"></ui-form-field>
    </div>

    <!-- To (recipient) -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.to_label' | translate }}</label>
      <ui-form-field type="text" [formControl]="form.controls.to" [placeholder]="'smart_inbox.inbox_view.conversation_list.advanced_filter.placeholder_recipient' | translate" [fullWidth]="true"></ui-form-field>
    </div>

    <!-- Subject -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.subject_label' | translate }}</label>
      <ui-form-field type="text" [formControl]="form.controls.subject" [placeholder]="'smart_inbox.inbox_view.conversation_list.advanced_filter.placeholder_subject' | translate" [fullWidth]="true"></ui-form-field>
    </div>

    <!-- From date -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.from_date_label' | translate }}</label>
      <ui-form-field type="datepicker" [formControl]="form.controls.dateFrom" [placeholder]="'smart_inbox.inbox_view.conversation_list.advanced_filter.placeholder_from_date' | translate" [fullWidth]="true" prefixIcon="calendar-cc" [maxDate]="dateFromMax"></ui-form-field>
    </div>

    <!-- To date -->
    <div class="conversation-advanced-filter__field">
      <label class="conversation-advanced-filter__label">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.to_date_label' | translate }}</label>
      <ui-form-field type="datepicker" [formControl]="form.controls.dateTo" [placeholder]="'smart_inbox.inbox_view.conversation_list.advanced_filter.placeholder_to_date' | translate" [fullWidth]="true" prefixIcon="calendar-cc" [minDate]="dateToMin" [maxDate]="today"></ui-form-field>
    </div>

    <!-- Has attachment -->
    <div class="conversation-advanced-filter__field conversation-advanced-filter__field--checkbox">
      <mat-checkbox [formControl]="form.controls.hasAttachment">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.has_attachment' | translate }}</mat-checkbox>
    </div>
  </div>

  <!-- Actions (sticky) -->
  <div class="conversation-advanced-filter__actions">
    <button type="button" class="conversation-advanced-filter__btn conversation-advanced-filter__btn--reset" (click)="onReset()">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.reset' | translate }}</button>
    <button type="button" class="conversation-advanced-filter__btn conversation-advanced-filter__btn--apply" (click)="onApply()">{{ 'smart_inbox.inbox_view.conversation_list.advanced_filter.apply' | translate }}</button>
  </div>
</div>
